// Contract 29 §3.4 / §5 / §6.10 — the legal documents.
//
// The three legacy modals were 1,785 lines of hardcoded English legal prose. That prose does NOT
// come back, in any form: not as source, not as i18n JSON. Legal text is CONTENT — authored by
// counsel, versioned on a legal cadence, translated by lawyers and auditable ("which version did
// this user accept?"). `globalSurface.legal.*` carries the CHROME only.

export const LEGAL_SLUGS = ['user-agreement', 'terms-of-service', 'privacy-policy'] as const
export type LegalDocumentSlug = (typeof LEGAL_SLUGS)[number]

/** BE-29-01's payload. Until that endpoint lands nothing constructs one. */
export interface LegalDocument {
  slug: LegalDocumentSlug
  /** Recorded alongside the signup consent so acceptance is auditable. */
  version: string
  locale: string
  format: 'html' | 'markdown'
  body: string
  effective_at: string
}

/**
 * The interim link-out target per slug. The slug is NOT the path — `terms-of-service` lives at
 * `/terms-of-use` (v3 `AuthFooter.vue:8`).
 *
 * ⚠ `user-agreement` is `null` because NO public page exists for it, which contract §3.4 flags as
 * a blocker on the interim: the consent sentence names three documents but Legal has published
 * two. A `null` href must therefore never render as a link — see `useLegalDocument`.
 */
export const LEGAL_HREFS: Record<LegalDocumentSlug, string | null> = {
  'terms-of-service': 'https://orphex.co/terms-of-use',
  'privacy-policy': 'https://orphex.co/privacy-policy',
  'user-agreement': null,
}

/**
 * How the caller must render a slug.
 *  • `external`   — a public page exists; link out with `target="_blank" rel="noopener"`.
 *  • `modal`      — a served document exists; render `LegalDocumentModal` (BE-29-01).
 *  • `unavailable`— nothing to point at. Say so; never render a dead link.
 */
export type LegalDocumentMode = 'external' | 'modal' | 'unavailable'
